import React from 'react';
import { useFormik } from 'formik';
import {Link, useNavigate} from "react-router-dom";
import * as yup from 'yup';
import {auth} from '../../../firebase.config';
import {sendPasswordResetEmail} from 'firebase/auth';
const ForgotPass = () => {
    const navigate = useNavigate();
    const [emailSent, setEmailSent] = React.useState(false);
    const validationSchema = yup.object({
      email: yup.string().email('Please enter a valid email address').required('Email is required'),
    });
    const formik = useFormik({
      initialValues: {
        email: '',
      },
      validationSchema: validationSchema,
      onSubmit: values => {
        sendPasswordResetEmail(auth,values.email)
        .then(() => {
          setEmailSent(true);
          setTimeout(
            () =>navigate("/login"), 
            2000
          );
          })
      },
    });
  return (
    <div className="container signup forms-wrapper">
        {
          emailSent &&
          (
            <div className="alert alert-success" style={{  position:"absolute",zIndex: 1,right: 0 }} role="alert">
              <h4 className="alert-heading">Password reset email sent!</h4>
              <hr/>
              <p className="mb-0">Please check your  Mail-box</p>
            </div>
          )
        }

        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card o-hidden border-0 shadow-lg my-5">
              <div className="card-body p-0">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="p-5">
                      <div className="text-center">
                        <h1 className="h4 text-gray-900 mb-4">Forgot Password</h1>
                      </div>
                       <form onSubmit={formik.handleSubmit} className="user">
                       <div className="form-group">
                          <label htmlFor="email">Email</label>
                          <input
                            id="email"
                            name="email"
                            type="email"
                            placeholder='Enter Email'
                            onChange={formik.handleChange}
                            value={formik.values.email} className="form-control form-control-user"
                          />
                          {formik.errors.email ? <div className='validation-err'>{formik.errors.email}</div> : null}
                        </div>
                        <div className="form-group">
                          <button type="submit" disabled={emailSent}  className="btn btn-primary btn-user btn-block" >Submit</button>
                        </div>
                        </form>
                        <div className="text-center">
                          <Link to={'/login'}>Back to Login</Link>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};


export default ForgotPass;